export const c_form_m_horizontal__group_label_m_no_padding_md_TranslateY = {
  "name": "--pf-c-form--m-horizontal__group-label--m-no-padding--md--TranslateY",
  "value": "calc(((((0.875rem * 1.3) - 0.875rem) / 2) + 0.875rem) - ((((1rem * 1.3) - 1rem) / 2) + 1rem))",
  "var": "var(--pf-c-form--m-horizontal__group-label--m-no-padding--md--TranslateY)"
};
export default c_form_m_horizontal__group_label_m_no_padding_md_TranslateY;